'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactShare = require('react-share');
var _throttle = require('lodash/throttle');var _throttle2 = _interopRequireDefault(_throttle);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);

var _components = require('../../components');

var _parkingConverter = require('../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _capitalizeFirstLetter = require('../../helpers/capitalizeFirstLetter');var _capitalizeFirstLetter2 = _interopRequireDefault(_capitalizeFirstLetter);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _getIconStatus = require('../../utils/getIconStatus');
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../constants');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _controlButtonsConfig = require('../../pages/ManagePropertiesPage/controlButtonsConfig');var _controlButtonsConfig2 = _interopRequireDefault(_controlButtonsConfig);
var _displayPrice = require('../../helpers/displayPrice');var _displayPrice2 = _interopRequireDefault(_displayPrice);

var _PropertyCell = require('./PropertyCell.scss');var styles = _interopRequireWildcard(_PropertyCell);
var _note = require('../../../static/icons/note.svg');var _note2 = _interopRequireDefault(_note);
var _isDescendant = require('../../utils/isDescendant');var _isDescendant2 = _interopRequireDefault(_isDescendant);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _images_placeholder = require('../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _formatTimeFromDate = require('../../helpers/formatTimeFromDate');var _formatTimeFromDate2 = _interopRequireDefault(_formatTimeFromDate);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var PropertyCell = function (_Component) {_inherits(PropertyCell, _Component);function PropertyCell() {var _temp, _this, _ret;_classCallCheck(this, PropertyCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { hover: false,
      showNote: false,
      shownPromotedTitle: false,
      isShareTooltipShown: false,
      isModalControlsOpen: false }, _this.


































































    setClickableAreaSize = function () {
      if (_this.propertyInfo && _this.clickableArea && _this.propertyPhoto) {
        var width = _this.propertyInfo.offsetWidth + _this.propertyPhoto.offsetWidth + 55;

        if (_this.propertyRow && _this.propertyRow.offsetLeft) {
          width += _this.propertyRow.offsetLeft;
        }

        width = 'width: ' + Math.floor(width * 1.05) + 'px;';

        _this.clickableArea.setAttribute('style', '' + width);
      }
    }, _this.

    hideNote = function (evt) {
      var isNoteIcon = _this.noteWrapper && (0, _isDescendant2.default)(_this.noteWrapper, evt.target);

      if (!isNoteIcon) {
        _this.setState({ showNote: false });
      }
    }, _this.

    handleClick = function (evt) {var
      classList = evt.target.classList;
      var isPromotedIcon = classList.contains('icon-promoted');
      var isFavoriteIcon = classList.contains('favoriteToggler');
      var isPromotedTitle = classList.contains(styles.promotedTitle);

      if (isFavoriteIcon) {
        _this.toggleFavorites(evt);
      }

      if (_this.state.shownPromotedTitle && !isPromotedTitle) {
        _this.setState({ shownPromotedTitle: false });
        evt.stopPropagation();
      } else if (isPromotedIcon && !_this.state.shownPromotedTitle) {
        _this.setState({ shownPromotedTitle: true });
        evt.stopPropagation();
      }return true;
    }, _this.

    openDetailsHandler = function (evt) {var
      classList = evt.target.classList;
      var isFavoriteIcon = classList.contains('favoriteToggler');
      var isNoteIcon = _this.noteWrapper && (0, _isDescendant2.default)(_this.noteWrapper, evt.target);
      var isControlButtons = _this.controlButtons && (0, _isDescendant2.default)(_this.controlButtons, evt.target);
      var isMoreControlsButton = _this.moreControlsButton && (
      (0, _isDescendant2.default)(_this.moreControlsButton, evt.target) || _this.moreControlsButton === evt.target);


      if (isFavoriteIcon || isNoteIcon || isControlButtons || isMoreControlsButton) {
        return;
      }

      if (!isFavoriteIcon && !isNoteIcon) {
        evt.stopPropagation();
      }var

      ctrlKey = evt.ctrlKey,metaKey = evt.metaKey;

      if (!_this.state.showNote) {
        setTimeout(function () {return _this.openDetails({ ctrlKey: ctrlKey, metaKey: metaKey });}, 0);
      } else {
        _this.openDetails(evt);
      }
    }, _this.

    openDetails = function (evt) {
      if (!_this.state.showNote) {
        var route = (0, _appendLocale2.default)(_this.props.locale, '/home_details/' + _this.props.id);
        if (evt.ctrlKey || evt.metaKey) {
          window.open(route);
        } else if (_this.props.isMobile) {
          if (_this.props.suppressLoading && _this.props.setPreloadData) {
            _this.props.suppressLoading(true).
            then(_this.props.setPreloadData(_this.generatePreloadData())).
            then(function () {return _reactRouter.browserHistory.push(route);});
          } else {
            _reactRouter.browserHistory.push(route);
          }
        } else {
          _this.openDetailsPopup();
        }
      }
    }, _this.

    handleHover = function () {
      if (_this.props.onHover) {
        _this.props.onHover({ id: _this.props.id, city: _this.props.cityEn });
      }
    }, _this.

    handleEdit = function (event) {
      event.stopPropagation();
      _this.props.editProperty(_this.props.id);
      var isForeignProperty = (0, _checkIsForeignAddress2.default)(_this.props.addressData);

      setTimeout(function () {
        _reactRouter.browserHistory.push(
        (0, _appendLocale2.default)(
        _this.props.locale, '/' + (isForeignProperty ? 'foreign_property' : 'property') + '/edit?id=' + _this.props.id));


      });
    }, _this.

    handleShare = function () {
      if (_this.props.isMobile) {
        _this.props.openModalShare(_this.props.id);
      } else {
        _this.setState({ isShareTooltipShown: true });
      }
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.share, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.managePropertiesPage);
    }, _this.

    handleSecondJump = function () {
      _this.props.openJumpToTopModal();
    }, _this.

    handleUpgradePackage = function () {
      _this.props.openUpgradePackageModal(_this.props.id);
    }, _this.

    closeControlsModal = function () {return _this.setState({ isModalControlsOpen: false });}, _this.
    openControlsModal = function () {return _this.setState({ isModalControlsOpen: true });}, _this.

    toggleFavorites = function (evt) {
      _this.props.toggleFavorite(_this.props.id);
      evt.stopPropagation();
      evt.preventDefault(); // way to stop propagation on iPhones
    }, _this.

    openDetailsPopup = function () {
      _this.props.openDetailsPopup(_this.generatePreloadData());
      (0, _analyticsManager.trackModalOpen)('property/' + _this.props.id);
    }, _this.

    generatePreloadData = function () {return {
        propertyId: _this.props.id,
        address: _this.props.addressData,
        price: _this.props.price,
        additionalInfo: {
          area: _this.props.area,
          floor: _this.props.floor === 0 ? _this.props.groundFloorTitle.toString() : _this.props.floor,
          parkingSpots: (0, _parkingConverter2.default)(_this.props.parkingSpots),
          rooms: _this.props.rooms },

        propertyType: _this.props.propertyType,
        optionType: _this.props.optionType };}, _this.


    toggleActivity = function () {return !_this.props.suspended && _this.props.updatePropertyActivity({
        ids: [_this.props.id],
        active: !_this.props.isActive });}, _this.


    formatShareData = function () {var _this$props =
      _this.props,thumbnail = _this$props.photo,id = _this$props.id,locale = _this$props.locale,sharingTitle = _this$props.sharingTitle;
      var sharingUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);

      return {
        sharingUrl: sharingUrl,
        sharingTitle: sharingTitle,
        thumbnail: thumbnail };

    }, _this.

    showChart = function (action, propertyViews) {var
      createdAt = _this.props.createdAt;
      var publishDate = (0, _moment2.default)(createdAt).format('DD/MM/YYYY');
      if (!_this.props.isMobile) {
        var start = new Date();
        start.setDate(start.getDate() - 10);
        _this.props.loadSinglePropertyAnalytics({
          ids: [_this.props.id],
          action: action,
          end: new Date(),
          start: start });

        _this.props.openChartOfViews({ publishDate: publishDate, propertyViews: propertyViews, analyticsAction: action });
      }
    }, _this.

    handleExposures = function () {return _this.showChart(_constants.analyticsEventAction.VIEW, _this.props.propertyViews);}, _this.
    handlePhone = function () {return _this.showChart(_constants.analyticsEventAction.SHOW_NUMBER, _this.props.propertyNumber);}, _this.
    handleFavourites = function () {return _this.showChart(_constants.analyticsEventAction.FAVOURITES, _this.props.propertyFavorites);}, _this.

    createControlButtonsRef = function (ref) {
      _this.controlButtons = ref;
    }, _this.

    clickHandlers = {
      handleShare: _this.handleShare,
      handleEdit: _this.handleEdit,
      handleSecondJump: _this.handleSecondJump,
      openDetailsPopup: _this.openDetailsPopup,
      toggleActivity: _this.toggleActivity,
      upgradePackage: _this.handleUpgradePackage }, _this.


    toggleAutoJumpActivity = function () {var _this$props$property =

      _this.props.property,id = _this$props$property.id,isActive = _this$props$property.is_active,isSuspended = _this$props$property.is_suspended,autoJumpEnabled = _this$props$property.is_autojump_enabled;

      if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updateAutoJumpToTopActivity({
          ids: [id],
          enable: !autoJumpEnabled });

      }
    }, _this.

    toggleHighlight = function () {var _this$props$property2 =

      _this.props.property,id = _this$props$property2.id,isPromoted = _this$props$property2.is_promoted,isActive = _this$props$property2.is_active,isSuspended = _this$props$property2.is_suspended;

      if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updatePropertyHighlighting({
          ids: [id],
          promote: !isPromoted });

      }
    }, _this.
    toggleTopPromotion = function () {var _this$props$property3 =
      _this.props.property,id = _this$props$property3.id,is_top_promoted = _this$props$property3.is_top_promoted,is_active = _this$props$property3.is_active,is_suspended = _this$props$property3.is_suspended,thumbnail = _this$props$property3.thumbnail;

      if (thumbnail && is_active && !is_suspended && !_this.props.disabledPromotionAction) {
        _this.props.updateTopPromotionActivity({
          ids: [id],
          promote: !is_top_promoted });

      } else {
        _this.props.openMessageModal({ message:
          _react2.default.createElement('div', null, _this.props.translate('managePage', 'requiredPromotionTopDescription')) });

      }
    }, _this.

    renderControlButton = function (_ref) {var _ref$props = _ref.props,className = _ref$props.className,restProps = _objectWithoutProperties(_ref$props, ['className']),icon = _ref.icon,title = _ref.title;return (
        _react2.default.createElement('button', _extends({
            className: (0, _classnames2.default)(styles.controlButton, className) },
          restProps),

          _react2.default.createElement('i', { className: 'icon icon-' + icon },
            _react2.default.createElement('i', { className: 'path1' }),
            _react2.default.createElement('i', { className: 'path2' }),
            _react2.default.createElement('i', { className: 'path3' }),
            _react2.default.createElement('i', { className: 'path4' }),
            _react2.default.createElement('i', { className: 'path5' }),
            _react2.default.createElement('i', { className: 'path6' }),
            _react2.default.createElement('i', { className: 'path7' })),

          !_this.props.isMobile && _react2.default.createElement('br', null),
          _react2.default.createElement('span', null, title)));}, _this.



    renderControlButtons = function () {
      if (!_this.props.editable) {
        return null;
      }var _this$props2 =










      _this.props,isActive = _this$props2.isActive,isMobile = _this$props2.isMobile,jumpToTopTooltipText = _this$props2.jumpToTopTooltipText,copyLinkText = _this$props2.copyLinkText,canSecondJump = _this$props2.canSecondJump,suspended = _this$props2.suspended,promoted = _this$props2.promoted,autoJumpEnabled = _this$props2.autoJumpEnabled;

      var buttonsConfig = (0, _controlButtonsConfig2.default)(_this.props, _this.clickHandlers);
      var isForeignProperty = (0, _checkIsForeignAddress2.default)(_this.props.addressData);

      var mobileControls =
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.propertyButtons, styles.mobileButtons) },
        _this.renderControlButton(buttonsConfig.share),
        !isForeignProperty &&
        _this.renderControlButton(buttonsConfig.upgradePackage),


        !isForeignProperty &&
        _react2.default.createElement('div', { className: styles.moveToTopButton },
          _this.renderControlButton(buttonsConfig.jumpToTop),
          isActive && _react2.default.createElement('div', { className: styles.moveToTopTooltip }, _this.renderAutoJumpDataTitle(), ' ')),



        canSecondJump && _this.renderControlButton(buttonsConfig.secondJumpToTop));



      var desktopControls =
      _react2.default.createElement('div', { className: styles.propertyButtons },
        _this.renderControlButton(buttonsConfig.share),
        _this.renderControlButton(buttonsConfig.edit),

        !isForeignProperty &&
        _react2.default.createElement('div', { className: styles.moveToTopButton },
          _this.renderControlButton(buttonsConfig.jumpToTop),
          isActive && _react2.default.createElement('div', { className: styles.moveToTopTooltip }, _this.renderAutoJumpDataTitle(), ' ')),



        _this.renderControlButton(buttonsConfig.preview),
        _this.renderControlButton(buttonsConfig.activity),
        !isForeignProperty &&
        _this.renderControlButton(buttonsConfig.upgradePackage),


        _this.state.isShareTooltipShown &&
        _react2.default.createElement(_components.ShareTooltip, {
          locale: _this.props.locale,
          className: 'manageProperty',
          sharingData: _this.formatShareData(),
          isTooltipShown: _this.state.isShareTooltipShown,
          copyLinkTitle: copyLinkText(),
          emailTitle: '' + _this.props.translate('propertyDetails', 'contacts', 'email'),
          hideTooltip: function hideTooltip() {return _this.setState({ isShareTooltipShown: false });} }));





      return (
        _react2.default.createElement('div', { className: styles.propertyDesc, ref: _this.createControlButtonsRef },
          isMobile ? _react2.default.createElement('hr', { className: styles.buttonDivider }) : null,
          isMobile ? mobileControls : desktopControls));


    }, _this.

    renderControlsModal = function () {
      if (!_this.props.isMobile) {return null;}
      var buttonsConfig = (0, _controlButtonsConfig2.default)(_this.props, _this.clickHandlers);

      return (
        _react2.default.createElement(_components.Modal, {
            isOpen: _this.state.isModalControlsOpen,
            onRequestClose: _this.closeControlsModal,
            className: 'mobileContacts',
            isRtl: _this.props.isRtl },

          _react2.default.createElement('div', { className: styles.mobileMoreControls, onClick: _this.closeControlsModal },
            _react2.default.createElement('div', { className: styles.controlRow },
              _this.renderControlButton(buttonsConfig.edit)),

            _react2.default.createElement('div', { className: styles.controlRow },
              _this.renderControlButton(buttonsConfig.preview)),

            _react2.default.createElement('div', { className: styles.controlRow },
              _this.renderControlButton(buttonsConfig.activity)))));




    }, _this.

    renderShareModal = function () {return _this.props.isMobile &&
      _this.props.modalShareId === _this.props.id &&
      _this.props.editable &&
      _this.props.isActive &&

      _react2.default.createElement(_components.Modal, {
          isOpen: _this.props.isModalShareOpen,
          onRequestClose: _this.props.hideModalShare,
          className: 'mobileContacts',
          isRtl: _this.props.isRtl },

        _react2.default.createElement(_components.ShareTooltip, {
          locale: _this.props.locale,
          hideModalShare: _this.props.hideModalShare,
          sharingData: _this.formatShareData(),
          copyLinkTitle: _this.props.copyLinkText(),
          emailTitle: '' + _this.props.translate('propertyDetails', 'contacts', 'email'),
          isMobile: true }));}, _this.




    renderInactiveOverlay = function () {
      if (_this.props.isActive || !_this.props.editable) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: styles.inactiveOverlay }));

    }, _this.

    renderPrice = function () {
      var isProject = _this.props.propertyEntityType === _constants.ENTITY_TYPES.PROJECT;
      return (0, _displayPrice2.default)(_this.props, styles, isProject);
    }, _this.

    renderNote = function () {return _this.props.propertyNote ?
      _react2.default.createElement('div', { className: styles.noteIconWrapper, ref: function ref(_ref2) {_this.noteWrapper = _ref2;} },
        _react2.default.createElement('img', {
          src: _note2.default,
          alt: '',
          className: styles.noteIcon,
          onClick: function onClick() {
            _this.setState({ showNote: !_this.state.showNote });
          } }),

        _this.state.showNote ?
        _react2.default.createElement('div', { className: styles.noteTooltip },
          _react2.default.createElement(_components.NoteInput, {
            value: _this.props.propertyNote,
            addNote: function addNote(note) {return _this.props.addPropertyNote(_this.props.id, note);} })) :


        null) :

      null;}, _this.

    renderSuspendedLabel = function () {return _this.props.editable && _this.props.suspended &&
      _react2.default.createElement('div', { className: styles.suspendedLabel },
        _this.props.suspendedTitle,
        _react2.default.createElement(_components.BottomTooltip, {
          className: 'suspendedTooltip',
          msg:
          _react2.default.createElement('span', null,
            _this.props.suspendedTooltipMessage,
            _react2.default.createElement('a', {
                href: 'mailto:' + _constants.supportEmail,
                className: 'link',
                onClick: function onClick(evt) {return evt.stopPropagation();} }, ' ', _constants.supportEmail)) }));}, _this.








    renderFavoriteIcon = function () {return (
        _react2.default.createElement('span', {
            ref: function ref(_ref3) {_this.favoriteIcon = _ref3;},
            className: (0, _classnames2.default)(styles.favoriteIcon, 'favoriteToggler', {
              'icon-favorite-active-with-border': _this.props.isFavorite,
              'icon-favorite-disabled': !_this.props.isFavorite }) },


          _react2.default.createElement('span', { className: 'path1 favoriteToggler' }),
          _react2.default.createElement('span', { className: 'path2 favoriteToggler' })));}, _this.



    renderLabelNew = function () {return _this.props.isNewProperty &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.labelNew, _this.props.className === 'multiPinList' && styles.multiPin) },
        _react2.default.createElement(_components.OMLabelNew, {
          label: _this.props.newPropertyLabel,
          title: _this.props.newPropertyTitle,
          isMobile: _this.props.isMobile,
          inMultiPin: _this.props.className === 'multiPinList' }));}, _this.




    renderLabelTop = function () {return _this.props.isTopPromotedProperty &&
      _react2.default.createElement('div', { className: styles.labelNew },
        _react2.default.createElement(_components.OMLabelTop, {
          label: 'TOP',
          isMobile: _this.props.isMobile }));}, _this.




    renderVRIcon = function (hasVRLink) {var _cx;return hasVRLink &&
      _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelVR, 'icon', 'icon-vr-view', (_cx = {}, _cx[styles.managePropertyVr] = _this.props.editable, _cx)) },
        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }),
        _react2.default.createElement('span', { className: 'path3' }),
        _react2.default.createElement('span', { className: 'path4' }),
        _react2.default.createElement('span', { className: 'path5' }));}, _this.



    renderMoreControlsButton = function () {return _this.props.editable && _this.props.isMobile &&
      _react2.default.createElement('button', {
          ref: function ref(_ref4) {_this.moreControlsButton = _ref4;},
          className: styles.moreControlsButton,
          onClick: _this.openControlsModal },

        _react2.default.createElement('span', null, '\xA0\u2022 \u2022 \u2022\xA0'));}, _this.



    renderClickableArea = function () {
      if (_this.props.isMobile || _this.props.className !== 'inManageProperties') {
        return null;
      }

      return (
        _react2.default.createElement('div', {
          ref: function ref(_ref5) {_this.clickableArea = _ref5;},
          className: styles.clickableArea,
          onClick: _this.openDetails }));


    }, _this.

    renderPropertyViews = function () {var _this$props3 =
      _this.props,openChartOfViews = _this$props3.openChartOfViews,propertyViews = _this$props3.propertyViews,propertyViewsText = _this$props3.propertyViewsText,locale = _this$props3.locale,className = _this$props3.className,isMobile = _this$props3.isMobile;
      if (!_this.props.editable) {
        return null;
      }
      var viewsIcon = !isMobile &&
      _react2.default.createElement('i', { className: 'icon-views' },
        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }),
        _react2.default.createElement('span', { className: 'path3' }),
        _react2.default.createElement('span', { className: 'path4' }),
        _react2.default.createElement('span', { className: 'path5' }),
        _react2.default.createElement('span', { className: 'path6' }),
        _react2.default.createElement('span', { className: 'path7' }),
        _react2.default.createElement('span', { className: 'path8' }),
        _react2.default.createElement('span', { className: 'path9' }),
        _react2.default.createElement('span', { className: 'path10' }),
        _react2.default.createElement('span', { className: 'path11' }));

      var viewsCount = propertyViews || 0;

      var buttonContent = locale === 'ru' ?
      [
      { id: 1, value: viewsIcon },
      { id: 2, value: propertyViewsText },
      { id: 3, value: viewsCount }] :

      [
      { id: 1, value: viewsIcon },
      { id: 2, value: viewsCount },
      { id: 3, value: propertyViewsText }];


      return (
        _react2.default.createElement('button', { className: styles.propertyViews, onClick: _this.handleExposures },
          buttonContent.map(function (item) {return _react2.default.createElement('div', { key: item.id }, item.value);})));


    }, _this.

    renderPhoneClicksCount = function () {
      if (!_this.props.editable) {
        return null;
      }

      var phoneClicksCount = _this.props.propertyNumber || 0;
      var isForeign = (0, _checkIsForeignAddress2.default)(_this.props.addressData);

      return !isForeign &&
      _react2.default.createElement('div', { className: styles.phoneClicksCount, onClick: _this.handlePhone },
        _react2.default.createElement('i', { className: 'icon icon-phone' }), '\xA0\xA0',
        _react2.default.createElement('span', null, phoneClicksCount));


    }, _this.

    renderFavouritesCount = function () {
      if (!_this.props.editable) {
        return null;
      }

      var favouritesCount = _this.props.propertyFavorites || 0;

      return (
        _react2.default.createElement('div', { className: styles.favouritesCount, onClick: _this.handleFavourites },
          _react2.default.createElement('i', { className: 'icon icon-favorite' }), '\xA0\xA0',
          _react2.default.createElement('span', null, favouritesCount)));


    }, _this.

    renderAutoJumpDataTitle = function () {var
      manualJumpDate = _this.props.property.manual_jump_date;

      if (!!manualJumpDate) {
        return '\n        ' +
        _this.props.jumpToTopTooltipText + '\n        ' +
        _this.props.translate('managePage', 'manualJumpDate') + ' \n        ' +
        (0, _formatTimeFromDate2.default)(manualJumpDate) + '\n      ';

      }

      return _this.props.jumpToTopTooltipText;
    }, _this.

    renderPromotions = function () {
      var isForeign = (0, _checkIsForeignAddress2.default)(_this.props.addressData);

      if (!_this.props.editable || isForeign) {
        return null;
      }var _this$props4 =

      _this.props,autoJumpEnabled = _this$props4.autoJumpEnabled,translate = _this$props4.translate,promoted = _this$props4.promoted,isTopPromotedProperty = _this$props4.isTopPromotedProperty,isCanManagePromotions = _this$props4.isCanManagePromotions;
      var autoJumpStatus = autoJumpEnabled ? 'Active' : 'Disabled';
      var promotionStatus = promoted ? 'Active' : 'Disabled';
      var topPromotionStatus = isTopPromotedProperty ? 'Active' : 'Disabled';

      var topPromotion = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.top_promotion', null);
      var highlight = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.promotion', null);
      var autoJump = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.jump_promotion', null);

      var promotionUntilTopPromotion = topPromotion.until && (0, _moment2.default)(topPromotion.until);
      var promotionUntilTopPromotionFormatted = promotionUntilTopPromotion && promotionUntilTopPromotion.utc().format('DD/MM/YYYY') || '-';

      var promotionUntilHighlight = highlight.until && (0, _moment2.default)(highlight.until);
      var promotionUntilHighlightFormatted = promotionUntilHighlight && promotionUntilHighlight.utc().format('DD/MM/YYYY') || '-';

      var promotionUntilAutoJump = autoJump.until && (0, _moment2.default)(autoJump.until);
      var promotionUntilAutoJumpFormatted = promotionUntilAutoJump && promotionUntilAutoJump.utc().format('DD/MM/YYYY') || '-';

      var dataTitleTopPromotion = '\n      ' + (
      topPromotionStatus === 'Active' ? translate('managePage', 'validUntil') + ': ' + promotionUntilTopPromotionFormatted : '') + '\n      ' +
      translate('topPromotion' + topPromotionStatus + 'RegularUserTitle').replace('___', String.fromCharCode(8207) + 'TOP') + '\n    ';

      var dataTitlePromotionStatus = '\n      ' + (
      promotionStatus === 'Active' ? translate('managePage', 'validUntil') + ': ' + promotionUntilHighlightFormatted : '') + '\n      ' +
      translate('highlight' + promotionStatus + 'RegularUserTitle') + '\n    ';

      var dataTitleAutoJumpStatus = '\n      ' + (
      autoJumpStatus === 'Active' ? translate('managePage', 'validUntil') + ': ' + promotionUntilAutoJumpFormatted : '') + '\n      ' +
      translate('autoJump' + autoJumpStatus + 'RegularUserTitle') + '\n    ';


      return (
        _react2.default.createElement('div', { className: styles.promotionsBlock },
          _react2.default.createElement('div', { className: styles.promotionsTitle }, translate('managePage', 'promotionsTitle')),
          _react2.default.createElement('div', null,
            _react2.default.createElement('i', {
                onClick: isCanManagePromotions && _this.toggleTopPromotion,
                'data-title': dataTitleTopPromotion,
                className: (0, _classnames2.default)('icon-top-promotion' +
                (0, _getIconStatus.addEnding)(topPromotionStatus.toLocaleLowerCase()),
                styles.iconTitle) },


              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }))),


          _react2.default.createElement('div', null,
            _react2.default.createElement('i', {
                onClick: isCanManagePromotions && _this.toggleHighlight,
                'data-title': dataTitlePromotionStatus,
                className: (0, _classnames2.default)('icon-promoted' +
                (0, _getIconStatus.addEnding)(promotionStatus.toLocaleLowerCase()),
                styles.iconTitle) },


              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }))),


          _react2.default.createElement('div', null,
            _react2.default.createElement('i', {
                onClick: isCanManagePromotions && _this.toggleAutoJumpActivity,
                'data-title': dataTitleAutoJumpStatus,
                className: (0, _classnames2.default)(styles.iconTitle, 'icon-auto-jump' + (0, _getIconStatus.addEnding)(autoJumpStatus.toLocaleLowerCase())) },

              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' })))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}PropertyCell.prototype.componentDidMount = function componentDidMount() {if (this.props.isMobile) {this.propertyCell.addEventListener('click', this.handleClick, true);}if (!this.props.isMobile) {this.favoriteIcon && this.favoriteIcon.addEventListener('click', this.toggleFavorites, true);}if (this.props.className !== 'inManageProperties' || this.props.isMobile) {this.propertyCell.addEventListener('click', this.openDetailsHandler, true);}if (this.props.className === 'inManageProperties' && !this.props.isMobile) {this.setClickableAreaSize();this._resizeHandler = (0, _throttle2.default)(this.setClickableAreaSize, 66); // Around 15 fps
      window.addEventListener('resize', this._resizeHandler);}if (this.props.autoDeactivatedProperty && this.props.autoDeactivatedProperty === this.props.id && this.props.isActive) {this.toggleActivity();}};PropertyCell.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref6) {var propertyNote = _ref6.propertyNote,autoDeactivatedProperty = _ref6.autoDeactivatedProperty;if (!propertyNote && this.props.propertyNote !== propertyNote) {this.setState({ showNote: false });}if (autoDeactivatedProperty && this.props.autoDeactivatedProperty !== autoDeactivatedProperty) {if (autoDeactivatedProperty === this.props.id && this.props.isActive) {this.toggleActivity();}}};PropertyCell.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {if (!prevState.showNote && this.state.showNote) {document.body.addEventListener('click', this.hideNote, true);}if (prevState.showNote && !this.state.showNote) {document.body.removeEventListener('click', this.hideNote, true);}};PropertyCell.prototype.componentWillUnmount = function componentWillUnmount() {if (this.props.isMobile) {this.propertyCell.removeEventListener('click', this.handleClick, true);}if (this._resizeHandler) {window.removeEventListener('resize', this._resizeHandler);}this.propertyCell.removeEventListener('click', this.openDetailsHandler, true);this.favoriteIcon && this.favoriteIcon.removeEventListener('click', this.toggleFavorites, true);}; // Uncomment to enable delete property modal
  // onDelete = (evt) => {
  //   evt.preventDefault();
  //   this.props.showDeleteModal(this.props.id);
  // };
  PropertyCell.prototype.render = function render() {var _this2 = this,_cx2;var _props = this.props,neighborhood = _props.neighborhood,city = _props.city,address = _props.address;var parkingSpots = (0, _parkingConverter2.default)(this.props.parkingSpots);var groundFloor = this.props.floor === 0;
    var favoriteButton = !this.props.editable && !this.props.hideFavoriteButton && this.renderFavoriteIcon();
    var isProject = this.props.propertyEntityType === _constants.ENTITY_TYPES.PROJECT;
    var image = (isProject ? (0, _modifyImageLink2.default)(this.props.photo) : this.props.photo) || _images_placeholder2.default;

    return (
      _react2.default.createElement('div', {
          ref: function ref(cell) {_this2.propertyCell = cell;},
          vocab: 'http://schema.org/',
          'typeof': 'Apartment',
          onMouseEnter: this.handleHover,
          className: (0, _classnames2.default)(
          styles.propertyCell,
          this.props.className, (_cx2 = {}, _cx2[

          styles.defaultCursor] = this.props.editable, _cx2[
          styles.promotedProperty] =
          this.props.promoted &&
          !this.props.editable &&
          this.props.className !== 'multiPinList', _cx2)) },




        _react2.default.createElement('div', {
            className: styles.propertyRow,
            ref: function ref(_ref9) {_this2.propertyRow = _ref9;} },

          _react2.default.createElement('div', { className: styles.iconsWrapper },
            this.renderNote(),
            !this.props.editable && this.renderVRIcon(this.props.hasVRLink),
            !isProject && this.renderLabelNew(),
            !this.props.editable && this.renderLabelTop(),
            this.renderMoreControlsButton()),


          _react2.default.createElement('div', { className: styles.propertyPhoto, ref: function ref(_ref7) {_this2.propertyPhoto = _ref7;} },
            !isProject && favoriteButton,
            this.props.editable && this.renderVRIcon(this.props.hasVRLink),

            _react2.default.createElement('img', { alt: '', property: 'photo', src: image }),
            this.renderPrice()),


          _react2.default.createElement('div', { className: styles.propertyDescription },
            this.props.className === 'multiPinList' ? this.renderPrice() : null,
            !isProject &&
            _react2.default.createElement('div', { className: styles.propertyType },
              this.props.editable ? this.props.optionAndPropertyTypes : this.props.propertyType),


            isProject &&
            _react2.default.createElement('div', { className: styles.propertyType },
              this.props.translate('header', 'projects')),


            _react2.default.createElement('div', { property: 'address', className: styles.propertyAddress },
              _react2.default.createElement('div', null, address),
              _react2.default.createElement('div', { className: styles.neighborhood },
                neighborhood && neighborhood !== city && _react2.default.createElement('div', null, neighborhood, ', \xA0'),
                _react2.default.createElement('div', null, city))),



            _react2.default.createElement('div', { className: styles.propertyInfo, ref: function ref(_ref8) {_this2.propertyInfo = _ref8;} },
              this.props.rooms &&
              _react2.default.createElement('span', { property: 'numberOfRooms', className: styles.propertyInfoIconContainer },
                _react2.default.createElement('i', { className: 'icon icon-door', title: this.props.roomsIconTitle }),
                this.props.rooms),



              (this.props.floor || groundFloor) &&
              _react2.default.createElement('span', { className: styles.propertyInfoIconContainer },
                _react2.default.createElement('i', { className: 'icon icon-floor' }),
                groundFloor ? this.props.groundFloorTitle : this.props.floor),



              this.props.status &&
              _react2.default.createElement('span', { className: styles.propertyInfoIconContainer },
                this.props.translate('status') + ': ' + this.props.status),



              this.props.area &&
              _react2.default.createElement('span', { className: styles.propertyInfoIconContainer },
                _react2.default.createElement('i', { className: 'icon icon-square', title: this.props.squareIconTitle }),
                this.props.area),



              parkingSpots ?
              _react2.default.createElement('span', { className: styles.propertyInfoIconContainer },
                _react2.default.createElement('i', { className: 'icon icon-parkingSpot', title: this.props.parkingIconTitle }),
                parkingSpots) :

              null)),






          _react2.default.createElement('div', { className: styles.controlButtons },
            _react2.default.createElement('div', { className: styles.topControlButtons },
              this.renderPromotions(),
              _react2.default.createElement('div', { className: styles.informationWrapper },
                _react2.default.createElement('div', { className: styles.information },
                  this.renderPhoneClicksCount(),
                  this.renderFavouritesCount()),

                this.renderPropertyViews())),


            this.renderControlButtons())),



        this.renderInactiveOverlay(),
        this.renderClickableArea(),
        this.renderSuspendedLabel(),
        this.renderShareModal(),
        this.renderControlsModal()));


  };return PropertyCell;}(_react.Component);exports.default = PropertyCell;


PropertyCell.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  photo: _propTypes2.default.string,
  price: _propTypes2.default.oneOfType([
  _propTypes2.default.string,
  _propTypes2.default.number]).
  isRequired,
  address: _propTypes2.default.string.isRequired,
  rooms: _propTypes2.default.number,
  parkingSpots: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func,
  id: _propTypes2.default.string,
  editButtonText: _propTypes2.default.func,
  openDetailsButtonText: _propTypes2.default.func,
  activeButtonText: _propTypes2.default.func,
  inactiveButtonText: _propTypes2.default.func,
  makeActiveText: _propTypes2.default.func,
  makeInactiveText: _propTypes2.default.func,
  upgradePackageButtonText: _propTypes2.default.func,
  jumpToTopText: _propTypes2.default.func,
  jumpToTopTooltipText: _propTypes2.default.func,
  copyLinkText: _propTypes2.default.func,
  editProperty: _propTypes2.default.func,
  isModalShareOpen: _propTypes2.default.bool,
  hideModalShare: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  openJumpToTopModal: _propTypes2.default.func,
  editable: _propTypes2.default.bool,
  city: _propTypes2.default.string,
  cityEn: _propTypes2.default.string,
  className: _propTypes2.default.string,
  optionAndPropertyTypes: _propTypes2.default.string,
  area: _propTypes2.default.number,
  parkingIconTitle: _propTypes2.default.func,
  roomsIconTitle: _propTypes2.default.func,
  squareIconTitle: _propTypes2.default.func,
  onHover: _propTypes2.default.func,
  isActive: _propTypes2.default.bool,
  updatePropertyActivity: _propTypes2.default.func,
  movePropertyToTop: _propTypes2.default.func,
  canMoveToTop: _propTypes2.default.bool,
  canSecondJump: _propTypes2.default.bool,
  floor: _propTypes2.default.number,
  groundFloorTitle: _propTypes2.default.func,
  addressData: _propTypes2.default.object,
  propertyType: _propTypes2.default.string,
  propertyNote: _propTypes2.default.string,
  addPropertyNote: _propTypes2.default.func,
  isFavorite: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  promoted: _propTypes2.default.bool,
  promotedTitle: _propTypes2.default.string,
  suspended: _propTypes2.default.bool,
  suspendedTitle: _propTypes2.default.string,
  suspendedTooltipMessage: _propTypes2.default.string,
  hideFavoriteButton: _propTypes2.default.bool,
  sharingTitle: _propTypes2.default.string,
  shareButtonText: _propTypes2.default.func,
  suppressLoading: _propTypes2.default.func,
  setPreloadData: _propTypes2.default.func,
  optionType: _propTypes2.default.string,
  isNewProperty: _propTypes2.default.bool,
  hasVRLink: _propTypes2.default.bool,
  newPropertyLabel: _propTypes2.default.string,
  newPropertyTitle: _propTypes2.default.string,
  autoDeactivatedProperty: _propTypes2.default.string,
  openChartOfViews: _propTypes2.default.func,
  propertyViews: _propTypes2.default.number,
  propertyFavorites: _propTypes2.default.number,
  propertyNumber: _propTypes2.default.number,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  propertyViewsText: _propTypes2.default.func,
  createdAt: _propTypes2.default.string,
  modalShareId: _propTypes2.default.string,
  autoJumpEnabled: _propTypes2.default.bool,
  isTopPromotedProperty: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openUpgradePackageModal: _propTypes2.default.func,
  propertyEntityType: _propTypes2.default.string,
  status: _propTypes2.default.string,
  searchOption: _propTypes2.default.string,
  neighborhood: _propTypes2.default.string,
  property: _propTypes2.default.object,
  userProperties: _propTypes2.default.object,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  disabledPromotionAction: _propTypes2.default.bool,
  isCanManagePromotions: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyCell/PropertyCell.js
// module id = 559
// module chunks = 0